import { defineMessages } from 'react-intl';

const messages = defineMessages({
  std_notif_txt: {
    id: '9pLB+Z',
    defaultMessage: 'Take me to Standard',
  },
  buy_now: {
    id: '6oJwp/',
    defaultMessage: 'Buy now on AWS',
  },
  concurrent_user: {
    id: 'wEzqAd',
    defaultMessage: 'Concurrent Users',
  },
  storage_text: {
    id: 'DUIDEq',
    defaultMessage: 'Storage',
  },
  appPoints_text: {
    id: 'cZlhoM',
    defaultMessage: 'AppPoints',
  },
  slider1_text: {
    id: 'wEzqAd',
    defaultMessage: 'Concurrent Users',
  },
  client_device_text: {
    id: 'GaIiSp',
    defaultMessage: 'Client Devices',
  },
  std_feat_pt3: {
    id: '9jIgCE',
    defaultMessage: 'Schedule Optimization',
  },
  tooltip_concurrent_users_text: {
    id: 'sEDFOt',
    defaultMessage:
      'Input the maximum number of users allowed to be logged into Maximo Application Suite as a Service at the same time.',
  },
  std_feat_pt4: {
    id: 'y/lg3R',
    defaultMessage: 'All Industry Solutions',
  },
  disclaimer_text: {
    id: 'mh5M29',
    defaultMessage:
      'Calculated prices are estimates provided for planning purposes only taking into account potential IBM discounts, and are not a formal offer from IBM or an IBM Business Partner. The estimation may reflect the total discounted price. Certain factors such as configuration, add-ons, or additional requirements will affect final price. IBM Business Partners set and provide their own IBM Maximo Application Suite pricing, and neither IBM nor IBM Business Partners are bound by the provided estimate.',
  },
  std_feat_pt1: {
    id: '731Dlz',
    defaultMessage: 'Predictive Maintenance',
  },
  std_feat_pt2: {
    id: 'owRFdi',
    defaultMessage: 'Remote Monitoring',
  },
  inference_text: {
    id: '2kUZey',
    defaultMessage: 'Inferences / Hour',
  },
  user_text: {
    id: 'YDMrKK',
    defaultMessage: 'Users',
  },
  estimated_text: {
    id: 'wNB/GH',
    defaultMessage: 'Estimated monthly cost',
  },
  tooltip_health_text: {
    id: 'uuzzY0',
    defaultMessage:
      'Input the maximum number of Health classifications required per hour.',
  },
  maas_saas_sub_headline: {
    id: '6B/nzv',
    defaultMessage:
      'Explore SaaS pricing options and determine the edition best suited to your organization',
  },
  slider3_text: {
    id: 'po3gaM',
    defaultMessage: 'Health Formula Scores',
  },
  std_feat_label: {
    id: 'bMhVwm',
    defaultMessage: 'All the features of Essentials, plus',
  },
  maas_saas_headline: {
    id: '5Sx9qr',
    defaultMessage: 'IBM Maximo Application Suite as a Service (SaaS)',
  },
  prem_pkg_desc: {
    id: 'UTo1Iv',
    defaultMessage:
      'Tailor a custom configuration that best suits your highly complex deployment needs, utilize maximum operational flexibility and leverage Maximo premium services. ',
  },
  std_label: {
    id: 'cb2kY6',
    defaultMessage: 'Standard',
  },
  prem_label: {
    id: 'C5xzTC',
    defaultMessage: 'Premium',
  },
  env_text: {
    id: 'JEgVUq',
    defaultMessage: 'Environments',
  },
  std_pkg_desc: {
    id: 'iqIrcj',
    defaultMessage:
      'Access to the full Maximo portfolio of applications, including predictive maintenance, remote monitoring, visual inspection, industry solutions, and integrations (ERP, HCM, SCM systems).',
  },
  col1_text: {
    id: 'FCjGve',
    defaultMessage: 'Requirement',
  },
  thank_you: {
    id: 'aYIUar',
    defaultMessage: 'Thank you!',
  },
  est_insp_feat_pt2: {
    id: 'DwCecP',
    defaultMessage: 'Quality Inspection',
  },
  est_insp_feat_pt1: {
    id: '2oiJlM',
    defaultMessage: 'Computer Vision AI',
  },
  bp_title: {
    id: 'BkHBGW',
    defaultMessage: 'Selected Business Partner',
  },
  toggle2_text: {
    id: 'IfyH18',
    defaultMessage: 'Non-Production Environment',
  },
  estimated_annual_text: {
    id: 'QsT4P9',
    defaultMessage: 'Estimated annual cost',
  },
  prem_notif_label: {
    id: 'vt9nHB',
    defaultMessage: 'Information notification',
  },
  no: {
    id: 'oUWADl',
    defaultMessage: 'No',
  },
  return_est_text: {
    id: '8fgwsI',
    defaultMessage: 'Return to price estimator',
  },
  prem_feat_label: {
    id: '5ky40J',
    defaultMessage: 'All the features of Standard, plus',
  },
  recommend_text_prem: {
    id: 'x8sXHY',
    defaultMessage: 'Need flexible deployment & operational policies?',
  },
  prcie_text: {
    id: 'cVxiy4',
    defaultMessage: 'Prices shown do not include tax',
  },
  bp_desc: {
    id: '9k14Pe',
    defaultMessage:
      'I consent to IBM providing my business contact information: ',
  },
  tooltip_auth_user_text: {
    id: '/rgqtR',
    defaultMessage:
      'Input the number of users who will have reserved access to IBM Maximo Application Suite as a Service.',
  },
  contact_info: {
    id: 'R6Ef/+',
    defaultMessage: 'For a solution of this size please get in touch with us.',
  },
  close_btn_text: {
    id: 'rbrahO',
    defaultMessage: 'Close',
  },
  est_label: {
    id: 'eXbuB9',
    defaultMessage: 'Essentials',
  },
  toggle1_info_pt2: {
    id: 'dhby3b',
    defaultMessage: 'Add up to 25 additional users',
  },
  toggle1_info_pt1: {
    id: 'wpAIZF',
    defaultMessage: 'Includes up to 25 users',
  },
  insp_est: {
    id: '9e/HVB',
    defaultMessage: 'Inspection Essentials',
  },
  est_pkg_desc: {
    id: 'wEqZop',
    defaultMessage:
      'Fast time to value for clients new to Maximo Application Suite. Select entry level packages for enterprise asset management and mobility, computer vision, space and workplace management, capital projects management, lease management, or MRO inventory optimization.',
  },
  recommend_text_std: {
    id: 'o/mpqD',
    defaultMessage: 'Need additional applications or capacity?',
  },
  work_order_text: {
    id: 'ul9wss',
    defaultMessage: 'Work Orders / Hour',
  },
  authorized_user: {
    id: 'BDJuF7',
    defaultMessage: 'Authorized Users',
  },
  gb_text: {
    id: 'LRu6Sn',
    defaultMessage: 'GB',
  },
  est_feat_label: {
    id: 'ZXp0z1',
    defaultMessage: 'Features',
  },
  prem_feat_pt2: {
    id: 'jTmyCs',
    defaultMessage: 'Advanced Deployment Options',
  },
  prem_notif_txt: {
    id: 'tMtWk6',
    defaultMessage: 'Take me to Premium',
  },
  quote_text: {
    id: 'r4tIGb',
    defaultMessage: 'Request a quote',
  },
  req_detail: {
    id: '0L49M8',
    defaultMessage: 'Request details:',
  },
  prem_feat_pt3: {
    id: 'g1t8/W',
    defaultMessage: 'Advanced Disaster Recovery Options',
  },
  prem_feat_pt1: {
    id: 'iCFDOh',
    defaultMessage: 'Tailored Configurations',
  },
  toggle2_info_pt1: {
    id: '0W8CbV',
    defaultMessage: 'Includes 1 Production environment',
  },
  package_label: {
    id: 'RcNFA2',
    defaultMessage: 'Package',
  },
  yes: {
    id: 'a5msuh',
    defaultMessage: 'Yes',
  },
  col2_text: {
    id: 'qVGRIE',
    defaultMessage: 'Quantity',
  },
  toggle2_info_pt2: {
    id: 'civjT5',
    defaultMessage: 'Add 1 Non-Production environment',
  },
  widgetText_3: {
    id: 'Udh8Vw',
    defaultMessage:
      'The estimated price includes the Maximo Application Suite Manage and Health applications. To estimate other applications or other combinations of applications, please request a quote.',
  },
  health: {
    id: 'hlmkcL',
    defaultMessage: 'Health',
  },
  received_text: {
    id: 'PwjLGb',
    defaultMessage: 'We have received your request',
  },
  health_score_text: {
    id: 'HKZwM2',
    defaultMessage: 'Health Formula Scores / Hour',
  },
  prem_feat_pt4: {
    id: 'KSHW9R',
    defaultMessage: 'Maximum Operational Flexibility',
  },
  toggle1_text: {
    id: 'WkFMc5',
    defaultMessage: 'Additional Users',
  },
  manage: {
    id: '0Azlrb',
    defaultMessage: 'Manage',
  },
  mnt_est: {
    id: 'KXVrrN',
    defaultMessage: 'Maintenance Essentials',
  },
  book_text: {
    id: 'fkklEf',
    defaultMessage: 'Book a Consultation',
  },
  est_mnt_feat_pt3: {
    id: 'Hi+Gt0',
    defaultMessage: 'Asset Health',
  },
  est_mnt_feat_pt2: {
    id: 'ymkSUN',
    defaultMessage: 'Mobile EAM',
  },
  est_mnt_feat_pt1: {
    id: 'fWbWxu',
    defaultMessage: 'Asset Management',
  },
  slider2_text: {
    id: 'BDJuF7',
    defaultMessage: 'Authorized Users',
  },
  est_user_qty_text: {
    id: 'pvhwiT',
    defaultMessage: 'Up to ',
  },
  est_mnt_feat_pt5: {
    id: 'kKjSrD',
    defaultMessage: 'Solutions available for multiple Industries',
  },
  est_mnt_feat_pt4: {
    id: '0I0F/S',
    defaultMessage: 'Reliability-Centered Maintenance',
  },
  applications: {
    id: 'fo7RD/',
    defaultMessage: 'Applications included in your estimate',
  },
  est_space_feat_pt1: {
    id: 'o0FT+k',
    defaultMessage: 'Space Management',
  },
  est_space_feat_pt2: {
    id: 'fnfkcw',
    defaultMessage: 'Reservation Management',
  },
  est_capt_feat_pt1: {
    id: '4Y1OgM',
    defaultMessage: 'Capital Project Management',
  },
  est_capt_feat_pt2: {
    id: 'EVesCh',
    defaultMessage: 'Facility Condition Assessment',
  },
  est_lease_feat_pt1: {
    id: '+TZXOO',
    defaultMessage: 'Lease Administration',
  },
  est_lease_feat_pt2: {
    id: 'e4mbDB',
    defaultMessage: 'Lease Accounting',
  },
  est_invopt_feat_pt1: {
    id: 'Evbabk',
    defaultMessage: 'ROP/MAX Recommendations',
  },
  est_invopt_feat_pt2: {
    id: 'Kb0J6T',
    defaultMessage: 'Recommendation Insights',
  },
  est_invopt_feat_pt3: {
    id: 'kyBQLB',
    defaultMessage: 'Filters and Sorting to Prioritize Actions',
  },
  est_invopt_feat_pt4: {
    id: '++qAzb',
    defaultMessage: 'Prioritization of Alerts & Risk',
  },
  reserv_text: {
    id: 'Dl/QGV',
    defaultMessage: 'Reservations users',
  },
  leases_text: {
    id: 'VdsWJi',
    defaultMessage: 'Leases',
  },
  aiService_text: {
    id: 'GW632p',
    defaultMessage: 'AI Service',
  },
  invent_optm_text: {
    id: 'fD5w5k',
    defaultMessage:
      'SaaS deployment, setup, and onboarding training are offered as a one-time service package, billed separately from the monthly subscription. This upfront fee of USD 17,000 is not included in the recurring monthly pricing.',
  },
  invent_size_text: {
    id: 'kUg3b2',
    defaultMessage: 'Inventory size value',
  },
  invent_item_text: {
    id: 'iEgW3P',
    defaultMessage: 'Inventory item records',
  },
  invent_item_text_disclaimer: {
    id: 's95etY',
    defaultMessage: 'The greater of:',
  },
  ai_desc_text: {
    id: 'jpZWlm',
    defaultMessage: 'Pre-integrated AI',
  },
  million_text: {
    id: 'JtF02P',
    defaultMessage: 'million',
  },
  brand1_label: {
    id: 'dudqv/',
    defaultMessage: 'Maintenance',
  },
  brand2_label: {
    id: 'uXm916',
    defaultMessage: 'Inspection',
  },
  brand3_label: {
    id: 'o0FT+k',
    defaultMessage: 'Space Management',
  },
  brand4_label: {
    id: 'BwmqDh',
    defaultMessage: 'Capital Planning',
  },
  brand5_label: {
    id: 'nG/+SS',
    defaultMessage: 'Lease Management',
  },
  brand6_label: {
    id: 'Ag1RDg',
    defaultMessage: 'Inventory Optimization',
  },
  toggle_helper_update_text: {
    id: 'S2TRGx',
    defaultMessage: 'Includes up to 20 users',
  },
  toggle_helper_desc_text: {
    id: 'dMbLJx',
    defaultMessage: 'Add up to 30 additional users',
  },
  error_msg1: {
    id: 'FI5F6Q',
    defaultMessage: 'Please provide range between 0 and 500',
  },
  error_msg2: {
    id: 'qvIvbs',
    defaultMessage: 'Please provide range between 0 and 1,500',
  },
  error_msg3: {
    id: 'ydHq66',
    defaultMessage: 'Please provide range between 1000 and 1,000,000',
  },
  lease_toogle_label: {
    id: 'oCCNdX',
    defaultMessage: 'Additional Leases',
  },
  lease_toogle_helper1: {
    id: 'HMFgZ9',
    defaultMessage: 'Includes up to 500 leases',
  },
  lease_toogle_helper2: {
    id: '5yXr4M',
    defaultMessage: 'Add up to 500 additional leases',
  },
});

export default messages;
